import { createGetTextResources } from "../shared/utils/text-resources-algemeen";

export const getRapportageTextResources = createGetTextResources({
  TooltipRapportageSelect: `Kies een onderdeel in onderstaande rapport om de tekst die in het rapport wordt opgenomen te raadplegen en eventueel te wijzigen. Na het selecteren van een onderdeel wordt de tekst aan de rechterzijde getoond en kan daar gewijzigd worden. Dit kan alleen als de beheerder rechten heeft gegeven om de teksten te wijzigen.`
});
